import { render, staticRenderFns } from "./gknav.vue?vue&type=template&id=76a32bce&scoped=true&"
import script from "./gknav.vue?vue&type=script&lang=js&"
export * from "./gknav.vue?vue&type=script&lang=js&"
import style0 from "./gknav.vue?vue&type=style&index=0&id=76a32bce&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76a32bce",
  null
  
)

export default component.exports